import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithRestApiByRequestUid,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import {
    CorporateActionsWidgetConfigState,
    initialCorporateActionsConfiguration,
} from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { CorporateActionsWidget } from 'widgets/corpActions/widget/CorporateActionsWidget';
import { AppMode } from 'app/store/general/AppMode';
import { corporateActionsStreamConfig } from 'widgets/corpActions/store/data/stream-config';
import { corporateActionsDescription } from 'widgets/corpActions/widget/description/corporateActionsDescription';
import { SymbolEventsRequest } from 'widgets/corpActions/api/SymbolEventsRequest';
import { SymbolEventsResponse } from 'widgets/corpActions/api/SymbolEventsResponse';

export const CorporateActionsTitle = 'Events';

export const corporateActionsWidgetStrategy: WidgetStrategyWithConfig<CorporateActionsWidgetConfigState> &
    WidgetStrategyWithRestApiByRequestUid<
        SymbolEventsRequest,
        SymbolEventsResponse
    > = {
    title: CorporateActionsTitle,
    supportedHosts: ['layout'],
    reactComponentType: CorporateActionsWidget,
    categories: [
        {
            appModes: [AppMode.STANDALONE],
            categories: [WidgetCategory.MULTIPLE_STOCK],
        },
        {
            appModes: [AppMode.EMBEDDED_DASHBOARD],
            categories: [WidgetCategory.PORTFOLIO],
        },
    ],
    description: corporateActionsDescription,
    initialConfigState: initialCorporateActionsConfiguration,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneOrder,
    managedStreamConfig: corporateActionsStreamConfig,
};
